module.exports = __webpack_public_path__ + "static/img/bg_title@2x.221cd23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ZBActivity/bg_title@2x.png
// module id = aFzB
// module chunks = 70